if (window.location.toString().includes("women")) {
      $("#item_dee4c75b-71a9-4909-8d8e-7ee0265fdd36").addClass(
        "is-action__hover"
      );
      $("#item_3944a4f5-3618-4f4b-9d13-238ddb1b72f2").removeClass(
        "is-action__hover"
      );
}
else{
	 $("#item_3944a4f5-3618-4f4b-9d13-238ddb1b72f2").addClass(
        "is-action__hover"
      );
      $("#item_dee4c75b-71a9-4909-8d8e-7ee0265fdd36").removeClass(
        "is-action__hover"
      );
	
}
$( "#t4s-nav-ul" ).on( "mouseleave", function() {
	 if (window.location.toString().includes("women")) {
      $("#item_dee4c75b-71a9-4909-8d8e-7ee0265fdd36").addClass(
        "is-action__hover"
      );
      $("#item_3944a4f5-3618-4f4b-9d13-238ddb1b72f2").removeClass(
        "is-action__hover"
      );
    } else {
		console.log("Men Navigation");
		 setTimeout(function () {
      $("#item_3944a4f5-3618-4f4b-9d13-238ddb1b72f2").addClass(
        "is-action__hover"
      );
      $("#item_dee4c75b-71a9-4909-8d8e-7ee0265fdd36").removeClass(
        "is-action__hover"
      );
	         }, 200);
    }
		} );
		
  $("#item_dee4c75b-71a9-4909-8d8e-7ee0265fdd36").mouseover(function(){
     $("#item_3944a4f5-3618-4f4b-9d13-238ddb1b72f2").removeClass(
        "is-action__hover"
      );
  });
  $("#item_3944a4f5-3618-4f4b-9d13-238ddb1b72f2").mouseover(function(){
     $("#item_dee4c75b-71a9-4909-8d8e-7ee0265fdd36").removeClass(
        "is-action__hover"
      );
  });
$(document).ready(function(){
// $(".t4s-product_social-share").appendTo(".ctl_productoptions ");
// $(".sshare").click(function(){
//   $(".t4s-product_social-share").toggle();


// });


  

	$("#store-locator__state option, #store-locator__city option").each(function() {
		$(this).siblings('[value="'+ this.value +'"]').remove();
	  });
	
	  $("#store-locator__state").on('change', function(){
		$('.t4s-store-locator__listings .t4s-store-locator__item').removeClass('show-item')
		$('#store-locator__city option').removeClass('show');
		const selecteVal = $(this).val(); console.log("State=", selecteVal)
		$('#store-locator__city option[data-state="'+selecteVal+'"]').addClass('show');
		$('#store-locator__city').val('0');



	  });



	

	  $("#store-locator__city").on('change', function(){
		$('.t4s-store-locator__listings .t4s-store-locator__item').removeClass('show-item')
		const selectedCity = $(this).val(); console.log("State=", selectedCity)
		// $('.t4s-store-locator__listings .t4s-store-locator__item p:contains("'+selectedCity+'")').addClass('show-item')
		$('.t4s-store-locator__listings .t4s-store-locator__item').each(function(){
			let $this = $(this);
			let getHtml = $this.text().toLowerCase(); console.log('getHtml', getHtml);
			if(getHtml.includes(selectedCity)){
				$this.addClass('show-item');
				setTimeout(function(){
					$('.t4s-store-locator__listings .t4s-store-locator__item.show-item:first').trigger('click');
				},500)
			} 
		})
	  });
    });


    $(document).ready(function() {
	
      if($('body').attr('data-template') == 'collection' || $('body').attr('data-template') == 'search'){
      // Function to check if all ".boost-sd__product-item" elements are loaded
      function checkElementsLoaded() {
          var allItemsLoaded = $(".boost-sd__product-item").length === $(".boost-sd__product-item:visible").length;
          console.log(allItemsLoaded+ "initail load");
          if (allItemsLoaded) {
              // Your script here
   
              var allitems = $(".boost-sd__product-item").length;
              // Your script here
              console.log(allitems+" items elements are rendered");
			    $(".boost-sd__product-item").each(function() {
				/*	  var customTagName = $(this).find('.boost-sd__product-label-text').text().trim();
			     console.warn(customTagName);
				   $(this).find('.boost-sd__product-label--customLabelByTag').addClass(customTagName);*/
				   	    $(".boost-sd__product-label--customLabelByTag").each(function() {
							 var customTagName = $(this).find('.boost-sd__product-label-text').text().trim();
							    $(this).addClass(customTagName);
                  $(this).css("display", "block"); 
				   				});
				});
			 
			
              $(".boost-sd__product-swatch-option").each(function() {
                  var labelText = $(this).find('.boost-sd__radio-label').text().trim();
                  $(this).find('.boost-sd__radio-label').addClass(function(index, currentClass) {
                      return labelText;
                  });
  
  
  
              });
  
        $(".boost-sd__btn-quick-view").click(function(){
          setTimeout(function(){ 
            console.log("quick view clicked");
            $(".boost-sd__product-swatch-option").each(function() {
              var labelText = $(this).find('.boost-sd__radio-label').text().trim();
              $(this).find('.boost-sd__radio-label').addClass(function(index, currentClass) {
                return labelText;
              });
      
      
      
            });
          }, 2000); 
  
  
  
      });

      $(".boost-sd__sorting-list").click(function(){
        setTimeout(function(){ 
        $(".boost-sd__product-item").each(function() {
                   $(".boost-sd__product-label--customLabelByTag").each(function() {
                 var customTagName = $(this).find('.boost-sd__product-label-text').text().trim();
                    $(this).addClass(customTagName);
                    $(this).css("display", "block"); 
                     });
          });
        }, 2000); 
    });
      
        
              
              // Stop the interval once elements are loaded
              clearInterval(intervalId);
  
              $(window).on("scroll", function() {
                  if(allitems != $(".boost-sd__product-item").length){
                      console.log("added more items")
						    $(".boost-sd__product-item").each(function() {
								var customTagdiv = $(this).find('.boost-sd__product-label-text');
					  /*var customTagName = $(this).find('.boost-sd__product-label-text').text().trim();
			     console.warn(customTagName);*/
				 	   	    $(".boost-sd__product-label--customLabelByTag").each(function() {
								
							
								
										  if (!$(customTagdiv).hasClass('customTagName')) {
					 var customTagName = $(this).find('.boost-sd__product-label-text').text().trim();
                $(this).addClass(customTagName);
                $(this).css("display", "block"); 
				 }
				   				});
	
				   
				});
                      $(".boost-sd__product-swatch-option").each(function() {
                          var labelText = $(this).find('.boost-sd__radio-label').text().trim();
                          $(this).find('.boost-sd__radio-label').addClass(function(index, currentClass) {
                              return labelText;
                          });
                      });
                  }

                  $(".boost-sd__btn-quick-view").click(function(){
                    setTimeout(function(){ 
                      console.log("quick view clicked");
                      $(".boost-sd__product-swatch-option").each(function() {
                        var labelText = $(this).find('.boost-sd__radio-label').text().trim();
                        $(this).find('.boost-sd__radio-label').addClass(function(index, currentClass) {
                          return labelText;
                        });
                
                
                
                      });
                    }, 2000); 
            
            
            
                });

              
                } );
          } else {
              console.log("Not all .boost-sd__product-item elements are loaded yet.");
          }
      }
  
      // Check every 500 milliseconds (adjust as needed)
      var intervalId = setInterval(checkElementsLoaded, 2000);
  
      setTimeout(checkElementsLoaded, 4000);
      }
  
  });
